import {Component, Input} from '@angular/core';
import {BreadcrumbComponent} from "../../common/breadcrumb/breadcrumb.component";

@Component({
    selector: 'app-admin-page-model',
    templateUrl: './admin-page-model.component.html',
    imports: [
        BreadcrumbComponent
    ],
    styleUrls: ['./admin-page-model.component.css']
})
export class AdminPageModelComponent {
  @Input()
  routeName: string;
  @Input()
  pageTitle: string;
}
